// @flow

import React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import CheckboxFilter from '../checkboxFilter';
import { getBucketTranslation } from '../../../store/assortmentSettings';
import { toggleTermFilter, isSelectedTermFilter } from '../../../store/assortment';

type OwnProps = {|
  count: number,
  bucket: string,
  label: string,
|};

type DispatchProps = {|
  filter: Function,
|};

type StateProps = {|
  isSelected: boolean,
  translation: Function,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
  ...StateProps,
|};

const CheckboxBucket = ({
  filter,
  translation,
  isSelected,
  count,
  bucket,
  label,
}: Props) => (
  <CheckboxFilter
    count={count}
    onChange={() => filter(label, bucket)}
    isSelected={isSelected}
    bucket={bucket}
    label={translation(bucket, label)}
  />
);

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  filter: (label: string, bucket: string) => dispatch(toggleTermFilter(label, bucket)),
});

const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => ({
  isSelected: isSelectedTermFilter(state, ownProps.label, ownProps.bucket),
  translation: (label: string, bucket: string) => getBucketTranslation(state, bucket, label),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(CheckboxBucket);
